export default __webpack_public_path__ + "static/media/fr.95747314.svg";